Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.CommentsMetricsView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']
  comments_metrics_template: JST['backbone/templates/monitoring/reports/publications/comments_metrics'] 

  initialize: (@options = {}, @header) ->
    # just set @options

  render_twitter:->
    @$el.html(@comments_metrics_template(@options))
    return this
    
  render: ->
    @$el.html(@comments_metrics_template(@options))
    return this

  fill_analytics: (data) ->
    comments_metrics_view = new Monitoring.Reports.Publications.Content.CommentView(data)

    sentiment_chart = new Monitoring.Reports.Campaign.SentimentDistributionView(data)
    sentiment_chart.genericSentimentChart(@getNegatives(data), @getNeutrals(data), @getPositives(data),'#bf362e', '#999999', '#84bd0e', '#f2f2f2' )
    if @header.include_comments_sentiment_metrics()
      @$el.find('.sentiment-metrics')[0].append(comments_metrics_view.render().el)
    if @header.include_sentiment_metrics_chart()
      @$el.find('.sentiment-metrics-chart')[0].append(sentiment_chart.el)

  getPositives: (data)->
    parseInt(data.sentiment.positive.replace(".", ""))

  getNegatives: (data)->
    parseInt(data.sentiment.negative.replace(".", ""))

  getNeutrals: (data)->
    parseInt(data.sentiment.neutral.replace(".", ""))
